module.exports = __webpack_public_path__ + "static/media/0008t.ce440435.jpg";